import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';

export interface BulkDeleteEapSettingsComponentProps {
    onClick: VoidFunction;
}

export const BulkDeleteEapSettingsComponent: React.FC<BulkDeleteEapSettingsComponentProps> = (props) => {
    const { onClick } = props;

    const { t } = useTranslation();

    return (
        <PocButton
            className="bulk-action"
            variant="tertiary"
            size="medium"
            onClick={onClick}
            data-testid="bulk-delete-eap-settings-button"
        >
            <PocIcon slot="prefix" name="delete" family="outlined" data-testid="bulk-delete-eap-settings-icon" />
            {t('settings.devices.eap-settings.eap-config-list.action.delete')}
        </PocButton>
    );
};
